module.exports = __webpack_public_path__ + "static/media/trypod_logo.214fbeed.png";